var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('wp-items-list',{attrs:{"content-type":"news-articles","content-type-singular":"news-article","content-name":"News articles","content-name-singular":"News article"}})}
var staticRenderFns = []

export { render, staticRenderFns }